import { MobileFrame } from 'room/in-person-mobile/mobile-frame'
import { Screen } from 'room/in-person-mobile/presentation/primitives'
import { ConfiguredLobbyHero } from './configured-lobby-in-person'
import { useInPersonLobbyMoment } from './in-person-lobby-moment'

/**
 * The in-person lobby on a phone or tablet: the same card the laptop shows
 * (`ConfiguredLobbyHero`), stacked - before the start, "starting soon" with
 * who leads; during a break, what follows it. Chat, agenda and boardlet stay
 * in the menu.
 */
export const LobbyInPersonMobile = (): JSX.Element => {
	const lobby = useInPersonLobbyMoment()
	const { moment } = lobby

	return (
		<MobileFrame
			live={false}
			testId={
				moment === 'not_started' ? 'in_person.not_started' : 'in_person.break'
			}
		>
			<Screen>
				<ConfiguredLobbyHero layout="phone" lobby={lobby} />
			</Screen>
		</MobileFrame>
	)
}

export default LobbyInPersonMobile
